<template>
	<!-- width="600px" 或者  width="60%"   -->
	<el-dialog
		:close-on-click-modal="false"
		title="添加文档"
		:show-close="true"
		:visible="true"
		:before-close="handleBeforeClose"
		width="625px"
	>
		<div class="dialog__container">
			<el-form
				inline
				ref="form"
				class="search-form"
				label-position="right"
				:model="form"
				:rules="rules"
				label-width="70px"
			>
				<el-form-item label="品牌：" prop="brand" class="input-with-col2 mr0">
					<el-input
						size="mini"
						v-model.trim="form.brand"
						placeholder="请输入品牌"
						clearable
					></el-input>
				</el-form-item>
				<el-form-item label="型号：" prop="model" class="input-with-col2 mr0">
					<el-input
						size="mini"
						v-model.trim="form.model"
						placeholder="请输入型号"
						clearable
					></el-input>
				</el-form-item>
        <el-form-item label="文档分类：" class="input-with-col2 mr0">
        	<el-select
        		size="mini"
        		v-model="form.documentType"
        		value-key="dictionaryCode"
        	>
        		<el-option
        			v-for="item in JSWDLXDicts"
        			:key="item.dictionaryCode"
        			:label="item.dictionaryValue"
        			:value="item"
        			placeholder="文档分类"
        		></el-option>
        	</el-select>
        </el-form-item>
				<el-form-item label="技术说明：" class="input-with-col2 mr0">
					<el-input
						size="mini"
						type="textarea"
						:rows="4"
						v-model.trim="form.content"
						placeholder="请输入技术说明"
						clearable
					></el-input>
				</el-form-item>
				<div v-for="(item, index) in form.documentItemList" :key="index">
					<el-form-item :label="`技术资源：`" class="input-with-col2 mr0">
						<el-upload
							class="upload-demo"
							:on-preview="handlePreview"
							:on-remove="(e) => handleRemove(index)"
							action="fakeaction"
							accept=".png, .jpg, .jpeg, .pdf, .mp4, .avi, .mov"
							:headers="token"
							:limit="1"
							:file-list="item.resourcesPath"
							:http-request="(e) => uploadFileRequest(e, index)"
						>
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">
								只能上传jpg/png/pdf/视频文件，且不超过500kb
							</div>
						</el-upload>
						<el-input
							size="mini"
							v-model.trim="item.description"
							placeholder="请输入说明"
							clearable
						></el-input>
					</el-form-item>
					<div style="font-size: 20px">
						<i
							v-if="form.documentItemList.length > 1"
							class="el-icon-remove-outline"
							style="cursor: pointer"
							@click="() => delectDocument(index)"
						></i>
						<i
							class="el-icon-circle-plus-outline"
							@click="addDocument"
							style="cursor: pointer"
						></i>
					</div>
				</div>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button
				class="plr28"
				size="mini"
				type="info"
				plain
				@click="handleCancel"
				>取消</el-button
			>
			<el-button
				class="plr28"
				type="primary"
				size="mini"
				:loading="loadBtn"
				@click="handleConfirm"
				>确定</el-button
			>
		</span>
	</el-dialog>
</template>

<script>
import { saveTechnicalDocument, uploadFile } from "@/api/TechnologyDocument";
import cookies from "../../../libs/util.cookies";
import { v4 as uuidv4 } from "uuid";
import { mapState } from 'vuex'
export default {
	data() {
		return {
			token: {
				Authorization: "Bearer " + cookies.get("token"),
			},
			fileList: [],
			form: {
        documentType: {},
				documentItemList: [
					{
						resourcesPath: [],
						description: "",
					},
				],
				brand: "",
				content: "",
				model: "",
			},
			rules: {
        documentType: [
          {
          	required: true,
          	message: "请选择文档类型",
          	trigger: "blur",
          },
        ],
				materialName: [
					{
						required: true,
						message: "请输入配件名称",
						trigger: "blur",
					},
				],
				costAmount: [
					{
						required: true,
						message: "请输入成本价",
						trigger: "blur",
					},
				],
				salesAmount: [
					{
						required: true,
						message: "请输入售价",
						trigger: "blur",
					},
				],
			},
			loadBtn: false,
		};
	},
  computed: {
  	...mapState("common/dictionary", [
  		"JSWDLXDicts"
  	]),
  },
	created() {},
	methods: {
		uploadFileRequest(params, index) {
			const file = params.file;
			// 根据后台需求数据格式
			const form = new FormData();
			// 文件对象
			form.append("file", file);
			uploadFile(form)
				.then((response) => {
					if (response.code === 200) {
						this.$message.success("上传成功");
						let data = response.data;
						let resource = this.form.documentItemList[index];
						resource.resourcesPath = [
							{
								name: data.name,
								url: data.url,
								resourcesPath: data.url,
								resourcesType: data.type,
							},
						];
						this.form.documentItemList.splice(index, 1, resource);
					} else {
						this.$message.error("上传失败，请联系管理员");
					}
				})
				.catch((error) => {
					console.log(error);
					this.$message.error("上传失败，请联系管理员");
				});
		},
		handleRemove(index) {
			let resource = this.form.documentItemList[index];
			resource.resourcesPath = [];
			this.form.documentItemList.splice(index, 1, resource);
		},

		addDocument() {
			this.form.documentItemList.push({
				resourcesPath: [],
				description: "",
			});
			console.log(this.form.documentItemList);
		},
		delectDocument(index) {
			this.form.documentItemList.splice(index, 1);
		},

		handlePreview(file) {
			window.open(file.resourcesPath, "_blank");
		},

		handleBeforeClose(done) {
			this.$emit("cancel");
			done();
		},
		handleCancel() {
			this.$emit("cancel");
		},
		async handleConfirm() {
			let documentItemList = [];
			if (this.form.documentItemList && this.form.documentItemList.length) {
				this.form.documentItemList.forEach((item) => {
					let obj = {
						description: item.description,
					};
					if (item.resourcesPath && item.resourcesPath.length) {
						const resources = item.resourcesPath[0];
						obj.resourcesType = resources.resourcesType;
						obj.resourcesPath = resources.url;
						obj.resourcesName = resources.name;
					}
					documentItemList.push(obj);
				});
			}
			if (this.loadBtn) return;
			this.$refs["form"].validate(async (valid) => {
				if (valid) {
					this.loadBtn = true;
					const params = {
						brand: this.form.brand,
						content: this.form.content,
						model: this.form.model,
						documentItemList,
					};
          params.documentTypeCode= this.form.documentType.dictionaryCode;
          params.documentTypeName= this.form.documentType.dictionaryValue;
          delete params.documentType;
					const res = await saveTechnicalDocument(params);
					if (res.code === 200) {
						this.$message.success("添加成功");
						this.$emit("confirm");
					}
					this.loadBtn = false;
				}
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/TechnologyDocument/components/AddCause.vue